import { Accordion, AccordionDetails, AccordionSummary, Avatar, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@src/components/ui/button/button';
import { MemberBadge } from '@src/components/common/badges/member-badge/member-badge';
import { CriminalCheckBadge } from '@src/components/common/badges/criminal-record-check-badge/criminal-record-check-badge';
import { GovIdVerifiedBadge } from '@src/components/common/gov-id-verified-badge/gov-id-verified-badge';
import { KeyboardArrowDown } from '@mui/icons-material';

export const SellerInfo = ({ badges, verifications, ...rest }) => {
    return (
        <div className='seller_info-section tw-p-6 tw-space-y-8 tw-bg-primary-200'>
            <div>
                <a href={`/storefront/${rest.id}`} className='tw-inline-flex tw-gap-4 tw-items-start'>
                    <Avatar alt={rest.displayName} src={rest.imageUrl} className='tw-mt-[4px]' />
                    <div className='tw-grow tw-flex tw-flex-col tw-justify-center tw-gap-[4px] tw-min-h-[50px]'>
                        <div className=' tw-flex tw-gap-[8px] tw-text-[#333333] tw-text-[16px] tw-font-[700]'>
                            <div>
                                {rest.businessName ? <div className='tw-font-medium'>{rest.businessName}</div> : null}
                                <div>{rest.displayName}</div>
                            </div>
                            {verifications.isGovIdVerified ? (
                                <GovIdVerifiedBadge className='tw-w-[24px] tw-aspect-square' />
                            ) : null}
                        </div>
                        <div className='tw-space-y-[4px]'>
                            <div className='tw-flex tw-gap-[4px] tw-flex-col'>
                                {verifications.isCriminalRecordVerified ? (
                                    <CriminalCheckBadge className='tw-w-[185px]' />
                                ) : null}
                                {badges.isMember ? <MemberBadge className='tw-w-[100px] tw-rounded-none' /> : null}
                            </div>
                            {badges.isMember && badges.showMembership && (
                                <span className='tw-block tw-text-[14px] tw-text-[#5A5A5A]'>
                                    BCAA Member since {badges.membershipJoinDate}
                                </span>
                            )}
                        </div>
                    </div>
                </a>
            </div>
            <p>{rest.description}</p>

            <div>
                <Accordion
                    disableGutters
                    elevation={0}
                    square
                    sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        '&::before': {
                            display: 'none'
                        }
                    }}
                >
                    <AccordionSummary
                        sx={{
                            padding: 0,
                            '& .caret-icon': {
                                transition: 'transform 0.3s ease'
                            },
                            '& .MuiAccordionSummary-expandIconWrapper': {
                                transform: 'none !important'
                            },
                            '&.Mui-expanded .caret-icon': {
                                transform: 'rotate(180deg)'
                            },
                            '&.Mui-expanded .number-badge': {
                                backgroundColor: '#0050C4',
                                color: '#FFFFFF'
                            }
                        }}
                    >
                        <Typography component='div' className='tw-flex tw-gap-2 tw-items-center'>
                            <KeyboardArrowDown className='caret-icon tw-text-[20px]' />
                            <span className='accordion-header-text tw-text-[14px] tw-font-medium'>Documents</span>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={{
                            padding: 0
                        }}
                    >
                        <div className='tw-space-y-[4px]'>
                            {rest.documents?.map(doc => (
                                <div key={doc.name} className='tw-flex tw-justify-between tw-items-center'>
                                    <div>{doc.name}</div>
                                    <div>
                                        <Button
                                            href={doc.url}
                                            variant='outlined'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            VIEW
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

SellerInfo.propTypes = {
    badges: PropTypes.shape({
        isMember: PropTypes.bool,
        showMembership: PropTypes.bool,
        membershipJoinDate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    }).isRequired,

    verifications: PropTypes.shape({
        isCriminalRecordVerified: PropTypes.bool,
        isGovIdVerified: PropTypes.bool
    }),

    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    displayName: PropTypes.string,
    businessName: PropTypes.string,
    imageUrl: PropTypes.string,
    description: PropTypes.string,
    documents: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string
        })
    )
};
